// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCheckMark_root__yWMOv"};